export default new class PersonalCartPromocode {
  constructor () {
    this.promocodeText = '.personal-cart__promocode';
    this.promocodeBtn = '.js-apply-promocode';
    this.promocodeErr = '.promocode_error';
    this.personalCartWrapperSelector = '.personal-cart__total-wrapper';
    this.personalCartFooterSelector = '.personal-cart__footer';
    this.containerSelector = '.product-list';
    this.init();
  }

  init() {
    if (!$(this.promocodeText)) return;
    this.bindEvents();
  }

  bindEvents()
  {
    $(document)
      // activate trial-subscribe access
      .on('click', this.promocodeBtn, (e) => {
        e.preventDefault();
        const promocode = document.querySelector(this.promocodeText).value;
        $.request('Promocode::onApplyPromocode', {
          data: {
            promocode: promocode,
          },
          update: {
            'project/common/personal-cart/personal-cart-total': this.personalCartWrapperSelector,
            'project/common/personal-cart/personal-cart-footer': this.personalCartFooterSelector,
          },
          complete: (result) => {
            if (!result.responseJSON.status) {
              document.querySelector('.promocode_error').innerText = 'Введённый промокод не верный'
              document.querySelector('.personal-cart__promocode').oninput = this.handlerInput
            }
          },
        });
      });

  }

  handlerInput() {
    document.querySelector('.promocode_error').innerText = ''
    document.querySelector('.personal-cart__promocode').oninput = undefined
  }

}
